export const SEARCH_FIELD_TYPES = {
  TEXT: 'text',
  SINGLE_SELECT: 'single_select',
  MULTIPLE_SELECT: 'multiple_select',
  DATE: 'date'
};
